module.exports = __webpack_public_path__ + "static/media/zachary-tan-1551160-unsplash.f07d0a2f.jpg";